import { combineReducers } from 'redux';

import mealEquivalent from './siteequivalent/reducer';

export default combineReducers({
  mealEquivalent,
});



// WEBPACK FOOTER //
// ./src/pages/mealequivalentsetup/state/reducer.js